// extracted by mini-css-extract-plugin
export default {"editButton":"PayrollMethod_editButton__QByja","TableBody":"PayrollMethod_TableBody__isO0w","deleteButton":"PayrollMethod_deleteButton__7rfOP"};